import { CognitoUserAttribute } from "amazon-cognito-identity-js";
import { createUserPool } from "./userPool";

export interface SignUpParams {
  email: string;
  name: string;
  password: string;
}

export function signUp({ email, name, password }: SignUpParams): Promise<void> {
  const { pool: userPool } = createUserPool();

  const attributes = [
    new CognitoUserAttribute({ Name: "email", Value: email }),
    new CognitoUserAttribute({ Name: "name", Value: name }),
  ];

  return new Promise((resolve, reject) => {
    userPool.signUp(email, password, attributes, [], (err) => {
      if (err) {
        reject(err);
        return;
      }
      resolve();
    });
  });
}
